import React, { useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import ButtonUI from "../../material-ui/ButtonUI";
import deleteRequestedClient from "../../../api/deleteRequestedClient";
import { AuthContext } from "../../../context/Auth/AuthContext";
import { DeleteActionButton } from "../../common/ActionIconButton";
import DeleteIcon from "@mui/icons-material/Delete";

/*** Component for showing the confirmation message before deleting the document request from document request table ***/
const DeletePopup = ({
  tableValues,
  setCategoryUpdatedToTrue,
  setRowSelection,
}) => {
  const [open, setOpen] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onDeleteDocumentFormSubmit = async () => {
    const deleteDocumentFormResponse = await deleteRequestedClient({
      token: token,
      docId: tableValues.document_request_id,
    });

    if (deleteDocumentFormResponse?.code === 200) {
      setOpen(false);
      setCategoryUpdatedToTrue();
      setRowSelection({});
      showSuccess("Document Request is deleted successfully");
    }
  };

  return (
    <div className="dialog-modal" title="Delete">
      <DeleteActionButton onClick={handleClickOpen} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <DeleteIcon />
          </div>
          <div className="popup-header-title">Delete Document Request</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this document request?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "##1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onDeleteDocumentFormSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeletePopup;
